import createReducer from "../createReducer";
import { Action } from "../action";
import { NotificationMessage, NotificationsActionsType } from "./notifications.actions";

export interface NotificationState {
  notification: NotificationMessage | undefined;
}

export const initialState: NotificationState = {
  notification: undefined,
};

export default createReducer(initialState, {
  [NotificationsActionsType.SHOW_SUCCESSFUL_REQUEST](
    state: NotificationState,
    action: Action<NotificationMessage>
  ): NotificationState {
    return { ...state, notification: action.payload };
  },
  [NotificationsActionsType.SHOW_FAILED_REQUEST](
    state: NotificationState,
    action: Action<NotificationMessage>
  ): NotificationState {
    return { ...state, notification: action.payload };
  },
  [NotificationsActionsType.SHOW_WARNING_REQUEST](
    state: NotificationState,
    action: Action<NotificationMessage>
  ): NotificationState {
    return { ...state, notification: action.payload };
  },
});
